/**
 * Helpers for address labels: primary billing vs shippingAddress[] from Account add/edit.
 */

function asText(v) {
  if (v == null || v === "") return "";
  if (typeof v === "string") return v;
  if (typeof v === "object" && v.name != null) return String(v.name);
  return String(v);
}

/** API may return shippingAddress as an array or legacy { allAddress: [] }. */
export function normalizeShippingAddressList(account) {
  if (!account || !account.shippingAddress) return [];
  const raw = account.shippingAddress;
  if (Array.isArray(raw)) return raw;
  if (raw.allAddress && Array.isArray(raw.allAddress)) return raw.allAddress;
  return [];
}

/**
 * Options for the print dropdown: primary billing + each shipping row.
 * @returns {{ key: string, label: string }[]}
 */
export function getAddressOptionsForAccount(account) {
  const options = [{ key: "billing", label: "Primary / billing address" }];
  const lines = normalizeShippingAddressList(account);
  lines.forEach((line, index) => {
    const hint = asText(line.fullname) || asText(line.address) || `Address ${index + 1}`;
    const short =
      hint.length > 48 ? `${hint.slice(0, 45)}…` : hint;
    options.push({
      key: `shipping_${index}`,
      label: `Shipping ${index + 1}: ${short}`,
    });
  });
  return options;
}

/**
 * Build the flat account shape used by AccountAddress / labels from API account + choice.
 * @param {string} choice - "billing" | "shipping_0" | "shipping_1" | ...
 */
export function applyAddressChoice(account, choice) {
  if (!account) return {};

  const partyName = account.name || account.accountName || "";
  const mobile = account.mobile || account.accountMobile || "";

  if (!choice || choice === "billing") {
    return {
      name: partyName,
      accountName: account.accountName || partyName,
      address: account.address || account.accountAddress || "",
      accountAddress: account.accountAddress || account.address || "",
      city: asText(account.city),
      state: asText(account.state),
      pin: account.pin || account.pincode || account.accountPin || "",
      pincode: account.pincode || account.pin || account.accountPin || "",
      mobile,
    };
  }

  const match = /^shipping_(\d+)$/.exec(choice);
  if (!match) {
    return applyAddressChoice(account, "billing");
  }

  const idx = parseInt(match[1], 10);
  const lines = normalizeShippingAddressList(account);
  const line = lines[idx];
  if (!line) {
    return applyAddressChoice(account, "billing");
  }

  const attn = asText(line.fullname);
  const displayName = attn ? `${partyName}${partyName && attn ? " — " : ""}${attn}` : partyName;

  return {
    name: displayName,
    accountName: account.accountName || partyName,
    address: asText(line.address),
    accountAddress: asText(line.address),
    city: asText(line.city),
    state: asText(line.stateAddress != null ? line.stateAddress : line.state),
    pin: asText(line.pincode != null ? line.pincode : line.pin),
    pincode: asText(line.pincode != null ? line.pincode : line.pin),
    mobile,
  };
}
